import { render, staticRenderFns } from "./TipAccount.vue?vue&type=template&id=7139b2de&scoped=true&"
import script from "./TipAccount.vue?vue&type=script&lang=js&"
export * from "./TipAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7139b2de",
  null
  
)

export default component.exports